import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { IEnvironment } from 'app/interfaces/iEnvironment';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService implements IEnvironment {
  get production(): boolean {
    return environment.production;
  }

  get baseConfigs(): any {
    return (environment as any).baseConfigs;
  }

  get randomPtsPhxUrl(): string {
    return (environment as any).randomPtsPhxUrl;
  }
}
